import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconNotebookWriting({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M22.631 14.87 15 22.5l-3.75.75.75-3.75 7.631-7.63a2.113 2.113 0 0 1 2.991 0l.009.008a2.116 2.116 0 0 1 0 2.992M8.25 20.25h-6a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h8.379a1.5 1.5 0 0 1 1.06.439l3.622 3.622a1.5 1.5 0 0 1 .439 1.06v5.372M3.75 5.25h3M3.75 9.75h3M3.75 14.25h3M9.75 5.25v9M12.75 9.75h-3" /></svg></>;
}
export default IconNotebookWriting;